import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import MallShelf from './mall-shelf/mall-shelf'
import { MALL_GOODS_SHELF } from './mall-shelf/router'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/mallShelf'} component={MallShelf}></Route>
            <Redirect from={props.match.path + '/settings'} to={MALL_GOODS_SHELF} />
        </Switch>
    )
}
